import i18n from 'i18next'
import HttpBackend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

const supportedLngs = ['fr', 'ar', 'en']
const fallbackLng = 'fr'
const privatePathPrefixes = ['/merchant', '/association']

function isPrivatePathname(pathname = '') {
    return privatePathPrefixes.some((prefix) => pathname.startsWith(prefix))
}

function applyHtmlLanguageAttributes(lang) {
    if (typeof document === 'undefined') return

    const normalized = supportedLngs.includes(lang) ? lang : fallbackLng
    const activeLang = normalized
    const dir = normalized === 'ar' ? 'rtl' : 'ltr'

    document.documentElement.lang = activeLang
    document.documentElement.dir = dir
    document.body?.setAttribute('data-dir', dir)
}

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs,
        fallbackLng,
        load: 'languageOnly',
        nonExplicitSupportedLngs: true,
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
        },
        detection: {
            // Keep an explicit user choice, otherwise always start in French.
            order: ['localStorage'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
            convertDetectedLanguage: (lng) => {
                if (!lng) return fallbackLng
                const base = String(lng).toLowerCase().split('-')[0]
                return supportedLngs.includes(base) ? base : fallbackLng
            },
        },
        react: {
            useSuspense: false,
        },
    })

export { supportedLngs, fallbackLng, applyHtmlLanguageAttributes, isPrivatePathname }
export default i18n
